<template>
  <div class="field">
    <label
      v-if="label && label.length > 0"
      class="label"
      v-html="label"
    />
    <div
      :class="{ 'is-active': isOpen }"
      class="dropdown dropdown-control"
    >
      <div class="dropdown-trigger">
        <p class="control has-icons-right">
          <input
            type="text"
            v-model="value"
            v-bind="setInputAttrs"
            class="input"
            autocomplete="disabled"
            @focus="openDropdown"
            @blur="closeDropdown"
          >
          <span class="icon is-small is-right">
            <ChevronDown />
          </span>
        </p>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a
            v-for="option in options"
            :key="option.code"
            role="menuitem"
            tabindex="0"
            class="dropdown-item"
            href="#"
            @click.prevent="selectOption($event, option)"
            @blur="closeDropdown"
          >{{ option.name }}</a>
        </div>
      </div>
    </div>
    <p
      v-if="message"
      :class="message.class"
      class="help"
      v-text="message.value"
    />
  </div>
</template>

<script>
import countries from '@/components/inputs/autocomplete/_countries'
import usStates from '@/components/inputs/autocomplete/_usStates'
import canadaStates from '@/components/inputs/autocomplete/_canadaStates'
import ChevronDown from 'vue-material-design-icons/ChevronDown'

export default {
  name: 'Autocomplete',
  components: {
    ChevronDown
  },
  data () {
    return {
      value: '',
      options: [],
      selectedOption: {},
      defaultData: [],
      isOpen: false
    }
  },
  props: {
    initialValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    dataSource: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    extraClass: {
      type: String,
      default: ''
    },
    label: {
      type: [Boolean, String],
      default: false
    },
    message: {
      type: [Boolean, Object],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.value = this.initialValue.name
    this.selectedOption = this.initialValue
    if (this.dataSource === 'countries') {
      this.defaultData = this.options = countries
    }
    if (this.dataSource === 'states') {
      if (this.initialValue.country === 'US') {
        this.defaultData = this.options = usStates
      } else if (this.initialValue.country === 'CA') {
        this.defaultData = this.options = canadaStates
      }
    }
  },
  computed: {
    setInputAttrs () {
      return {
        placeholder: this.placeholder,
        class: this.extraClass,
        name: this.name,
        disabled: this.disabled
      }
    }
  },
  watch: {
    value () {
      if (this.value.length > 0) {
        this.performSearch()
      } else {
        this.options = this.defaultData
        this.selectedOption = {}
      }
    },
    selectedOption () {
      this.emitValue()
    }
  },
  methods: {
    openDropdown (e) {
      e.target.setSelectionRange(0, e.srcElement.value.length)
      this.isOpen = true
    },
    closeDropdown () {
      setTimeout(() => {
        if (document.activeElement.className.match('dropdown-item') === null) {
          this.isOpen = false
          this.options = this.defaultData
        }
        this.emitValue()
      }, 250)
    },
    emitValue () {
      if (Object.keys(this.selectedOption).length === 0) {
        this.$emit('changedValue', {})
      } else {
        this.$emit('changedValue', this.selectedOption)
      }
    },
    selectOption (e, option) {
      this.value = option.name
      this.selectedOption = option
      e.srcElement.blur()
    },
    performSearch () {
      if (this.isOpen) {
        this.options = []

        this.defaultData.map(item => {
          let lookupData = item.name.toLowerCase()
          let re = new RegExp(this.value.toLowerCase(), 'gm')

          if (lookupData.toLowerCase().match(re) !== null) {
            this.options.push(item)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .help{
    position: absolute;
  }
  .dropdown{
    &.is-active{
      .icon{
        transform: rotate(180deg);
      }
    }
  }
  .dropdown-control{
    position: relative;
    width: 100%;

    .dropdown-trigger, input, .dropdown-menu{
      width: 100%;
    }

    .dropdown-content{
      max-height: 200px;
      overflow: auto;
    }
  }
</style>
